const $inject = [];

const deepCopyFilter = () => {
  return deepCopy;

  function deepCopy(o) {
    if (typeof o !== 'object'||o === null) return o;
    let newO, i;

    if (o instanceof Array) {
      let l;
      newO = [];
      for (i = 0, l = o.length; i < l; i++) newO[i] = deepCopy(o[i]);
      return newO;
    }

    newO = {};
    for (i in o) if (o.hasOwnProperty(i)) newO[i] = deepCopy(o[i]);

    return newO;
  }
};

deepCopyFilter.$inject = $inject;

export default deepCopyFilter;



// WEBPACK FOOTER //
// ./src/filters/deepCopyFilter.js